import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    contentBtn: {
        marginTop: 10,
        marginBottom: 10,
        paddingHorizontal: 25,
        width: '100%'
    },
    btn: {
        padding: 10,
        borderRadius: 20
    },
    textBtn: {
        color: '#fff',
        textAlign: 'center',
        fontSize: 18,
        fontWeight: '500'
    }
});

export default styles;
